import { useEffect, useRef } from 'react';
import { removeNotifiedExpired, removeExpiredWaitlists } from '../services/waitlistService';

/**
 * Hook: useWaitlistCleanup
 * Limpa automaticamente waitlists expirados e notificados há mais de 24h
 * Executa apenas para owners
 */
export const useWaitlistCleanup = (currentUser) => {
  const intervalRef = useRef(null);

  useEffect(() => {
    // Só executar para owners
    if (!currentUser || currentUser.role !== 'owner') {
      return;
    }

    // Obter ID da barbearia do owner (suporta formato antigo e novo)
    const barbershopId = currentUser.barbershopId || (currentUser.barbershops && currentUser.barbershops[0]);
    
    if (!barbershopId) {
      console.warn('Owner não tem barbearia associada');
      return;
    }

    const cleanupWaitlist = async () => {
      try {
        console.log('🧹 Iniciando limpeza automática de waitlist...');
        
        // Remover waitlists com data passada
        const expiredResult = await removeExpiredWaitlists(barbershopId);
        
        // Remover waitlists notificados há mais de 24h
        const notifiedResult = await removeNotifiedExpired(barbershopId);
        
        const totalRemoved = (expiredResult.removed || 0) + (notifiedResult.removed || 0);
        
        if (totalRemoved > 0) {
          console.log(`✅ Limpeza concluída: ${totalRemoved} waitlists removidos`);
        }
      } catch (error) {
        console.error('Erro na limpeza automática de waitlist:', error);
      }
    };

    // Executar imediatamente ao montar (quando o owner abre o app)
    cleanupWaitlist();

    // Fallback: executar a cada 12 horas (economia de leituras Firebase)
    intervalRef.current = setInterval(() => {
      cleanupWaitlist();
    }, 12 * 60 * 60 * 1000); // 12 horas

    // Cleanup ao desmontar
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [currentUser]);

  return null;
};
